import { memo } from 'react';

const PanelStack = ({ children, gap = 'default', className = '' }) => {
  const gapClass = gap === 'compact' ? ' panel-stack--compact' : '';
  const extraClass = className ? ` ${className}` : '';

  return (
    <div className={`panel-stack${gapClass}${extraClass}`}>
      {children}
    </div>
  );
};

export default memo(PanelStack);
